import { render, staticRenderFns } from "./conversionrecord.vue?vue&type=template&id=3260b8ae&scoped=true"
import script from "./conversionrecord.vue?vue&type=script&lang=js"
export * from "./conversionrecord.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3260b8ae",
  null
  
)

export default component.exports